var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_27361)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.179688,
    width: 32.1797,
    height: 32.1797,
    rx: 12.0674,
    fill: "#F6EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0785 9.5625C12.322 9.5625 10.894 10.9905 10.894 12.7469C10.894 14.4699 12.2416 15.8644 13.998 15.9247C14.0517 15.918 14.1053 15.918 14.1455 15.9247C14.1589 15.9247 14.1656 15.9247 14.1791 15.9247C14.1858 15.9247 14.1858 15.9247 14.1925 15.9247C15.9087 15.8644 17.2562 14.4699 17.2629 12.7469C17.2629 10.9905 15.835 9.5625 14.0785 9.5625Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4843 17.7087C15.6138 16.4617 12.5634 16.4617 10.6796 17.7087C9.82817 18.2785 9.35889 19.0495 9.35889 19.8741C9.35889 20.6987 9.82817 21.463 10.6729 22.0261C11.6115 22.6563 12.845 22.9714 14.0786 22.9714C15.3121 22.9714 16.5457 22.6563 17.4843 22.0261C18.329 21.4563 18.7983 20.692 18.7983 19.8607C18.7916 19.0361 18.329 18.2718 17.4843 17.7087Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.4464 13.1427C21.5537 14.4433 20.6285 15.583 19.348 15.7372C19.3413 15.7372 19.3413 15.7372 19.3346 15.7372H19.3145C19.2743 15.7372 19.2341 15.7372 19.2005 15.7506C18.5502 15.7841 17.9536 15.5763 17.5044 15.1941C18.1949 14.5773 18.5905 13.6522 18.51 12.6466C18.4631 12.1035 18.2754 11.6074 17.9938 11.1851C18.2486 11.0577 18.5435 10.9772 18.8452 10.9504C20.1592 10.8365 21.3324 11.8153 21.4464 13.1427Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7876 19.3438C22.734 19.9941 22.3183 20.5572 21.6211 20.9394C20.9507 21.3081 20.106 21.4824 19.2679 21.4623C19.7506 21.0265 20.0322 20.4835 20.0858 19.907C20.1529 19.0756 19.7573 18.2779 18.9663 17.641C18.5171 17.2856 17.9942 17.0041 17.4243 16.7962C18.9059 16.3672 20.7697 16.6555 21.9161 17.5806C22.5328 18.0767 22.8479 18.7002 22.7876 19.3438Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_27361"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.179688,
    width: 32.1797,
    height: 32.1797,
    rx: 16.0898,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.76a9c8d11abd28ffd3a169736c4aa14b.svg";
export { ForwardRef as ReactComponent };